<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <div class="bread" v-else-if="$route.query.type == 3">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">公开课</span>
    </div>
    <SearchKeyWords></SearchKeyWords>
    <Classify
      class="classify"
      :class="{
        'classify-top': !$route.query.recommend && !$route.query.keywords,
      }"
      :items="classifyItems"
      @change="onClassifyChange"
    ></Classify>
    <!-- 添加会员免费筛选条件 -->
    <div class="sort-content">
      <ListSort v-if="!recommend" v-model="sort" :isOpen="isOpen"></ListSort>
      <VipSort
        v-if="
          $store.getters.showVip && !recommend && $route.name != 'OpenCourse'
        "
        :vipCourse="vipCourse"
        @change="changeVipSort"
      ></VipSort>
    </div>
    <List
      class="list"
      ref="list"
      url="/api/app/courseBasis"
      :search="params"
      :limit="16"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="course-list clearfix">
          <template v-for="course in list">
            <RichCourseItem :key="course.id" :course="course"></RichCourseItem>
          </template>
        </div>
        <Empty
          v-if="list.length == 0"
          class="empty"
          title="暂无课程安排，敬请期待！"
        />
      </template>
    </List>
  </div>
</template>
<script>
import List from "@/components/List.vue";
import RichCourseItem from "@/modules/stu/components/rich/CourseItem.vue";
import Classify from "@/modules/stu/components/Classify.vue";
import ListSort from "@/modules/stu/components/ListSort.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";
import VipSort from "@/modules/stu/components/VipSort.vue";

export default {
  name: "Course",
  components: {
    List,
    Classify,
    RichCourseItem,
    SearchKeyWords,
    ListSort,
    VipSort,
  },
  data() {
    return {
      classifyList: [],
      classify: 0,
      subClassify: 0,
      attrCondition: {},
      attrs: [],
      courseClassifyData: {},
      sort: 0,
      courseType:
        this.$route.name == "OpenCourse" || this.$route.query.title == "公开课"
          ? 3
          : 1, // 默认普通课程
      recommend: this.$route.query.recommend,
      vipCourse: {},
    };
  },
  computed: {
    isOpen() {
      return this.courseType == 3;
    },
    keywords() {
      return this.$route.query.keywords;
    },
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    classifyItems() {
      let items = [];
      items.push({
        id: "classify",
        name: "课程分类",
        value: { item: this.classify, child: this.subClassify },
        children: this.classifyList,
      });
      this.attrs.forEach(c => {
        let item = {
          id: c.id,
          name: c.name,
          value: { item: this.attrCondition[c.id] },
          children: c.child,
        };
        items.push(item);
      });
      return items;
    },
    params() {
      let params = {
        course_type: this.courseType,
        classify_id: this.subClassify || this.classify,
        keywords: this.keywords,
        order_by: this.sort,
      };
      console.log(params);
      if (this.$route.query.nav) {
        params.nav_id = this.$route.query.nav;
      }
      let attrValIds = [];
      for (let key in this.attrCondition) {
        let valId = this.attrCondition[key];
        if (valId != 0) {
          attrValIds.push(valId);
        }
      }
      params.attr_val_id = attrValIds.join(",");
      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }
      // 会员免费课筛选项

      params.is_vip = this.vipCourse.checked ? 1 : 0;

      if (this.vipCourse.vipLevel) {
        params.vip_id = this.vipCourse.vipLevel;
      }
      return params;
    },
  },
  watch: {
    keywords: async function () {
      await this.getCourse(true);
    },
    async $route() {
      await this.$nextTick();
      this.init();
      await this.getClassify();
      this.courseType =
        this.$route.name != "OpenCourse" && this.$route.query.recommend != 3
          ? 1
          : 3;
      await this.getCourse(true);
    },
    sort() {
      this.getCourse(true);
    },
  },
  async created() {
    this.init();
    await this.getClassify();
  },
  mounted() {
    // this.$kefu()
  },
  methods: {
    init() {
      this.classify = 0;
      this.subClassify = 0;
      this.course_type = this.$route.query.course_type || 0;
      this.recommend = this.$route.query.recommend;
      //会员页面点击更多跳转到课程列表页，默认选中会员
      if (this.$route.query.vip) {
        this.vipCourse.checked = true;
        this.vipCourse.vipLevel = this.$route.query.vip_id
          ? parseInt(this.$route.query.vip_id)
          : "";
      }
    },
    async getClassify() {
      let params = {};
      if (this.$route.query.nav) {
        params.nav_id = this.$route.query.nav;
      }
      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }
      let data = await this.$http.get("/api/app/courseClassify", params);
      data.classify.unshift({ id: 0, name: "全部" });
      data.classify.forEach(c => {
        if (!c.children) {
          return;
        }
        c.children.unshift({ id: 0, name: "全部" });
      });
      this.classifyList = data.classify;
      this.courseClassifyData = data;
      let attrs = data.attrclassify;
      attrs.forEach(attr => {
        attr.child.unshift({
          id: 0,
          name: "全部",
        });
        this.$set(this.attrCondition, attr.id, 0);
      });
      this.attrs = attrs;
    },
    getCourse(refresh = false) {
      if (refresh) {
        this.$refs.list.searchRefresh();
      }
    },
    onClassifyChange({ id, value }) {

      if (id == "type") {
        this.courseType = value.item;
      } else if (id == "classify") {
        this.classify = value.item;
        this.subClassify = value.child;
      } else {
        this.attrCondition[id] = value.item;
      }

            console.log(123,this.classify)
      this.getCourse(true);
    },
    changeVipSort(data) {
      this.vipCourse = data;
      this.getCourse(true);
    },
  },
};
</script>
<style lang="scss" scoped>

.item {
  width: 276px;
  margin-top: 10px;
}

.classify {
  margin: 0;
}

.classify-top {
  margin: 24px 0;
}

.empty {
  margin-bottom: 30px;
}

/deep/ .el-pagination {
  margin: 16px 0 46px 0;
}

.course-list {
  /deep/ {
    .item {
      margin-bottom: 30px;
    }
  }
}
.sort-content {
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
